// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TicketManagment-main-container {
  margin-top: 27px;
}
.Ticket-Main-Table-Container {
  margin: -16px 0px;
}
.CreateTicketContainer {
  margin-top: -20px;
}
.TicketManagment-Container001 {
  padding: 0px 24px;
}
.Ticket-container-render {
  padding: 0px 24px;
}
.Ticket-text {
  color: #061522;
  font-family: "Inter";
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}
.Ticket-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
}
.profile-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ticket-export-actions {
  flex-shrink: 0;
  margin-left: auto;
}
.ticket-export-form {
  display: inline-flex;
  flex-shrink: 0;
}
.ticket-export-select-value {
  color: #405261;
  font-size: 14px;
  font-family: Inter, sans-serif;
  font-weight: 400;
  display: inline-flex;
  align-items: center;
}
.ticket-export-placeholder {
  color: #405261;
}
.Ticket-main-header {
  align-items: center;
  margin-top: 33px;
  /* cursor: pointer; */
}
.Ticket-text-section {
  display: flex;
  gap: 24px;
}
.ticket-header-text {
  color: #405261;
  cursor: pointer;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
.TicketHeaderActive {
  color: #061522;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  border-bottom: 1px solid #148dfd;
  padding-bottom: 8px;
}
.go-back {
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  padding: 32px 0px 0px 24px;
}
.create-ticket-heading {
  color: #061522;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 75% */
}

.css-19ms82e {
  width: 100%;
  margin-bottom: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/DashboardPages/TicketManagment/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,QAAQ;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".TicketManagment-main-container {\n  margin-top: 27px;\n}\n.Ticket-Main-Table-Container {\n  margin: -16px 0px;\n}\n.CreateTicketContainer {\n  margin-top: -20px;\n}\n.TicketManagment-Container001 {\n  padding: 0px 24px;\n}\n.Ticket-container-render {\n  padding: 0px 24px;\n}\n.Ticket-text {\n  color: #061522;\n  font-family: \"Inter\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n}\n.Ticket-title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 16px;\n}\n.profile-header-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.ticket-export-actions {\n  flex-shrink: 0;\n  margin-left: auto;\n}\n.ticket-export-form {\n  display: inline-flex;\n  flex-shrink: 0;\n}\n.ticket-export-select-value {\n  color: #405261;\n  font-size: 14px;\n  font-family: Inter, sans-serif;\n  font-weight: 400;\n  display: inline-flex;\n  align-items: center;\n}\n.ticket-export-placeholder {\n  color: #405261;\n}\n.Ticket-main-header {\n  align-items: center;\n  margin-top: 33px;\n  /* cursor: pointer; */\n}\n.Ticket-text-section {\n  display: flex;\n  gap: 24px;\n}\n.ticket-header-text {\n  color: #405261;\n  cursor: pointer;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n.TicketHeaderActive {\n  color: #061522;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  border-bottom: 1px solid #148dfd;\n  padding-bottom: 8px;\n}\n.go-back {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  cursor: pointer;\n  padding: 32px 0px 0px 24px;\n}\n.create-ticket-heading {\n  color: #061522;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 75% */\n}\n\n.css-19ms82e {\n  width: 100%;\n  margin-bottom: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
